import { Component, OnInit } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../carta/services';
import { Globals } from '../../../globals';
import { DishServices } from '../../dish/services';
import { ProductsServices } from '../../products/services';
import { MenuServices } from '../../menu/services';
import { ComboServices } from '../../combo/services';

/**
 * Generated class for the CartaMenuViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-menu-view',
  templateUrl: 'carta-menu-view.html',
})
export class CartaMenuViewPage implements OnInit {
  type: any;
  state: string = 'view';
  uid_element: any;
  valueChanges_dish: any;
  valueChanges_product: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public cartaServices: CartaServices,
    public globals: Globals,
    public dishServices: DishServices,
    public productsServices: ProductsServices,
    public menuServices: MenuServices,
    public comboServices: ComboServices) {

    this.type = this.navParams.get('type');
    this.uid_element = this.navParams.get('uid_element');
    this.state = this.navParams.get('state');

    if (this.type === 'carta') {
      this.loadCartaViewData();
    } else if (this.type === 'menu') {
      this.loadMenuViewData();
    } else {//combo
      this.loadComboViewData();
    }


  }
  ngOnInit() {
    //do nothing
  }

  ngOnDestroy() {
    if (this.type === 'carta') {
      if (this.cartaServices.valueChanges) {
        this.cartaServices.valueChanges.unsubscribe();
      }
    } else if (this.type === 'menu') {
      if (this.menuServices.valueChanges) {
        this.menuServices.valueChanges.unsubscribe();
      }
    } else {//combo
      if (this.comboServices.valueChanges) {
        this.comboServices.valueChanges.unsubscribe();
      }
    }
  }

  loadCartaViewData() {
    this.cartaServices.cartasDoc = this.cartaServices.afs.doc('cartas/' + this.uid_element);
    this.cartaServices.valueChanges = this.cartaServices.cartasDoc.valueChanges().subscribe(value => {
      value.UID = this.uid_element; //Anadimos el UID a la carta
      if (value.pages) {
        this.cartaServices.pages_array_tmp = this.globals.objectToArray(value.pages);
      } else {
        this.cartaServices.pages_array_tmp = [{ sections: [] }];
        value.pages = [{ sections: [] }];
      }
      if (value.order_share == undefined) {
        value.order_share = 0;
      }
      this.cartaServices.carta_tmp = value;
      this.cartaServices.getIndexOfPage();
      //generamos url de share
      this.cartaServices.url_share_xxss = this.globals.share_path + this.globals.domini_sites + "/" + this.type + "/" + this.uid_element + "?lang=" + this.globals.restaurant.lang;
      this.loadCartaMenuViewIframe();
    });
  }


  loadMenuViewData() {
    this.menuServices.menuDoc = this.menuServices.afs.doc('menus/' + this.uid_element); //Recuperamos el menu
    this.menuServices.valueChanges = this.menuServices.menuDoc.valueChanges().subscribe(value => {
      if (value) {
        value.UID = this.uid_element;
        //For amb els plats de la seccio
        this.menuServices.sections_array_tmp = this.globals.objectToArray(value.sections);
        if (value.extras_section) {
          this.menuServices.sections_extra_array_tmp = this.globals.objectToArray(value.extras_section);
        } else {
          this.menuServices.sections_extra_array_tmp = [];
        }
        if (value.order_share == undefined) {
          value.order_share = 0;
        }
        this.menuServices.menu_tmp = value;
        //generamos url de share
        this.menuServices.url_share_xxss = this.globals.share_path + this.globals.domini_sites + "/" + this.type + "/" + this.uid_element + "?lang=" + this.globals.restaurant.lang;
        this.loadCartaMenuViewIframe();
      }
    });
  }

  async loadComboViewData() {
    this.menuServices.menuDoc = this.menuServices.afs.doc('menus/' + this.uid_element); //Recuperamos el menu
    this.comboServices.valueChanges = this.menuServices.menuDoc.valueChanges().subscribe(value => {
      if (value) {
        value.UID = this.uid_element; //Anadimos el UID al plato
        if (value.image == undefined) {
          value.image = "";
        }
        //For amb els plats de la seccio
        this.menuServices.sections_array_tmp = this.globals.objectToArray(value.sections);
        if (value.extras_section) {
          this.menuServices.sections_extra_array_tmp = this.globals.objectToArray(value.extras_section);
        } else {
          this.menuServices.sections_extra_array_tmp = [];
        }
        if (value.order_share == undefined) {
          value.order_share = 0;
        }
        //
        this.menuServices.menu_tmp = value;
        //generamos url de share
        this.comboServices.url_share_xxss = this.globals.share_path + this.globals.domini_sites + "/" + this.type + "/" + this.uid_element + "?lang=" + this.globals.restaurant.lang;
        this.loadCartaMenuViewIframe();
      }
    });
  }

  async loadCartaMenuViewIframe() {
    const iframe = document.getElementById("loadCartaMenuViewIframe") as HTMLIFrameElement;
    if (iframe) {
      if (this.type === 'carta') {
        iframe.src = this.cartaServices.url_share_xxss + "&header=false";
      } else if (this.type === 'menu') {
        iframe.src = this.menuServices.url_share_xxss + "&header=false";
      } else {//combo
        iframe.src = this.comboServices.url_share_xxss + "&header=false";
      }
    }
  }

  pay() {
    var final_path = this.globals.api_path + "suscription/" + this.globals.user_email + "/stripe/carta-menu/month";
    //
    if (this.globals.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/cartas-menus/carta-menu-view/carta-menu-view.ts